import { Box, Button, Center, Collapse, Icon, Spinner } from "@chakra-ui/react";
import RGrid from "@raiden/library/components/RGrid";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { Fragment } from "react";
import { MdArrowDownward } from "react-icons/md";
import { FormattedMessage, useIntl } from "react-intl";
import Splash from "../../../components/Splash";
import SWRInfiniteHandler from "../../../components/SWR/SWRInfiniteHandler";
import { useSearchInfiniteContext } from "../../SearchInfinite/useSearchInfiniteContext";
import ArticleCard from "../../../components/Articles/Card";

function Results() {
  const intl = useIntl();

  const { swrInfiniteResponse, reset } = useSearchInfiniteContext();

  return (
    <SWRInfiniteHandler
      swrInfiniteResponse={swrInfiniteResponse}
      loading={
        <Center>
          <Spinner size="xl" color="brandPrimary.600" />
        </Center>
      }
      noResult={
        <Splash
          title={intl.formatMessage({ defaultMessage: "Aucun résultat" })}
          description={intl.formatMessage(
            {
              defaultMessage:
                "Nous sommes désolés, aucun résultat ne correspond à vos critères.{br}Essayez de retirer des filtres ou de réintialiser votre recherche.",
            },
            {
              br: "\u000A",
            },
          )}
          src={generateFrontPath({
            id: "internal-assets",
            parameters: { filePath: "illustrations/empty-public.svg" },
            includeBasePath: true,
          })}
          addon={
            <Button
              onClick={reset}
              variant="outline"
              colorScheme="brandSecondary"
              height="52px"
              borderRadius="full"
              isLoading={swrInfiniteResponse.isValidating}>
              <FormattedMessage defaultMessage="Réinitialiser ma recherche" />
            </Button>
          }
        />
      }>
      {(apiResponses) => (
        <Box>
          <RGrid gridGap="1.5rem" minCellWidth="300px">
            {apiResponses.map((apiResponse, index) => (
              <Fragment key={index}>
                {apiResponse.data.map((post) => (
                  <ArticleCard post={post} key={post.id} />
                ))}
              </Fragment>
            ))}
          </RGrid>

          <Collapse in={apiResponses.length < apiResponses[0].meta.last_page}>
            <Center pt="40px">
              <Button
                onClick={() => {
                  swrInfiniteResponse.setSize((size) => size + 1);
                }}
                isLoading={swrInfiniteResponse.isValidating}
                leftIcon={<Icon as={MdArrowDownward} />}
                variant="outline"
                colorScheme="brandSecondary"
                height="52px"
                borderRadius="full">
                <FormattedMessage defaultMessage="Afficher plus de résultats" />
              </Button>
            </Center>
          </Collapse>
        </Box>
      )}
    </SWRInfiniteHandler>
  );
}

export default Results;
